import {
	aiChatStream,
	aiChat
} from '@/api/voice'
import {
	Message
} from 'element-ui'
import {
	getToken
} from '@/utils/auth'

import {
	BASE_URL
} from '@/utils/const'

// AI聊天服务类
class AIChatService {
	constructor() {
		this.baseURL = BASE_URL
		this.abortController = null
	}

	/**
	 * 流式聊天对话
	 * @param {Array} messages 消息数组
	 * @param {Object} options 选项
	 * @param {Object} callbacks 回调函数
	 */
	async streamChat(messages, options = {}, callbacks = {}) {
		// 取消之前的请求
		if (this.abortController) {
			this.abortController.abort()
		}

		this.abortController = new AbortController()

		const requestData = {
			messages,
			options: {
				model: options.model || 'doubao-pro',
				temperature: options.temperature || 0.7,
				top_p: options.top_p || 0.9,
				max_tokens: options.max_tokens || 4096,
				...options,
			},
			session_id: options.session_id || this.generateSessionId(),
		}
		
		try {
			const token = getToken()
			const headers = {
				'Content-Type': 'application/json',
			}

			if (token) {
				headers['Authorization'] = 'Bearer ' + token
			}

			const response = await fetch(`${this.baseURL}/index/chat/stream`, {
				method: 'POST',
				headers,
				body: JSON.stringify(requestData),
				credentials: 'include',
				signal: this.abortController.signal,
			})

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`)
			}

			if (!response.body) {
				throw new Error('Response body is null')
			}

			const reader = response.body.getReader()
			const decoder = new TextDecoder('utf-8')
			let buffer = ''
			let flag = true;
			while (flag) {
				const {
					done,
					value
				} = await reader.read()
				// console.log('done', done)
				// console.log('value', value)
				// console.log('value-----------------')
				if (done) {
					if (callbacks.onDone) {
						callbacks.onDone()
					}
					break
				}

				buffer += decoder.decode(value, {
					stream: true
				})

				// console.log('buffer', buffer)
				const lines = buffer.split('\n')
				buffer = lines.pop() || '' // 保留未完成的行

				for (const line of lines) {
					if (line.trim() === '') continue

					if (line.startsWith('data: ')) {
						const dataStr = line.substring(6).trim()

						if (dataStr === '[DONE]') {
							if (callbacks.onDone) {
								callbacks.onDone()
							}
							return
						}

						try {
							const data = JSON.parse(dataStr)

							if (data.event === 'message' && callbacks.onMessage) {
								callbacks.onMessage(data)
							} else if (data.event === 'complete' && callbacks.onComplete) {
								callbacks.onComplete(data)
							} else if (data.event === 'error' && callbacks.onError) {
								callbacks.onError(data?.message || '未知错误')
							}
						} catch (e) {
							console.error('解析SSE数据失败:', e, dataStr)
						}
					}
				}
			}

		} catch (error) {
			if (error.name === 'AbortError') {
				console.log('请求已被取消')
			} else {
				console.error('流式请求失败:', error)
				if (callbacks.onError) {
					callbacks.onError(error.message || '请求失败')
				}
				Message.error('请求失败: ' + error.message)
			}
		} finally {
			this.abortController = null
		}
	}
	
	async cozeStream(url, options = {}, callbacks = {}) {
		// 取消之前的请求
		if (this.abortController) {
			this.abortController.abort()
		}

		this.abortController = new AbortController()

		let requestData = {}

		requestData = {
			...requestData,
			...options
		}

		// try {
		const token = getToken()
		const headers = {
			'Content-Type': 'application/json',
		}

		if (token) {
			headers['Authorization'] = 'Bearer ' + token
		}

		const response = await fetch(`${this.baseURL}/index/${url}`, {
			method: 'POST',
			headers,
			body: JSON.stringify(requestData),
			credentials: 'include',
			signal: this.abortController.signal,
			responseType: 'stream', // 关键
		})

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`)
		}

		if (!response.body) {
			throw new Error('Response body is null')
		}

		const reader = response.body.getReader()
		const decoder = new TextDecoder('utf-8')
		let buffer = ''
		let flag = true;
		while (flag) {
			const {
				done,
				value
			} = await reader.read()

			if (done) {
				if (callbacks.onDone) {
					callbacks.onDone()
				}
				break
			}

			buffer += decoder.decode(value, {
				stream: true
			})

			const lines = buffer.split('\n')
			buffer = lines.pop() || '' // 保留未完成的行

			for (const line of lines) {
				if (line.trim() === '') continue

				if (line.startsWith('data: ')) {
					const dataStr = line.substring(6).trim()

					if (dataStr === '[DONE]') {
						if (callbacks.onDone) {
							callbacks.onDone()
						}
						return
					}

					// try {
					const data = JSON.parse(dataStr)

					if (data.event === 'message' && callbacks.onMessage) {
						callbacks.onMessage(data)
					} else if (data.event === 'complete' && callbacks.onComplete) {
						callbacks.onComplete(data)
					} else if (data.event === 'error' && callbacks.onError) {
						callbacks.onError(data?.message || '未知错误')
					}
					// } catch (e) {
					// 	console.error('解析SSE数据失败 e:', e)
					// 	console.error('fail dataStr: ', dataStr)
					// }
				}
			}
		}
	}

	/**
	 * 流式聊天对话
	 * @param {Array} messages 消息数组
	 * @param {Object} options 选项
	 * @param {Object} callbacks 回调函数
	 */
	async customeStream(url, options = {}, callbacks = {}) {
		// 取消之前的请求
		if (this.abortController) {
			this.abortController.abort()
		}

		this.abortController = new AbortController()

		let requestData = {}

		requestData = {
			...requestData,
			...options
		}

		// try {
		const token = getToken()
		const headers = {
			'Content-Type': 'application/json',
		}

		if (token) {
			headers['Authorization'] = 'Bearer ' + token
		}

		const response = await fetch(`${this.baseURL}/index/${url}`, {
			method: 'POST',
			headers,
			body: JSON.stringify(requestData),
			credentials: 'include',
			signal: this.abortController.signal,
			responseType: 'stream', // 关键
		})

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`)
		}

		if (!response.body) {
			throw new Error('Response body is null')
		}

		const reader = response.body.getReader()
		const decoder = new TextDecoder('utf-8')
		let buffer = ''
		let flag = true;
		while (flag) {
			const {
				done,
				value
			} = await reader.read()

			if (done) {
				if (callbacks.onDone) {
					callbacks.onDone()
				}
				break
			}

			buffer += decoder.decode(value, {
				stream: true
			})

			const lines = buffer.split('\n')
			buffer = lines.pop() || '' // 保留未完成的行

			for (const line of lines) {
				if (line.trim() === '') continue

				if (line.startsWith('data: ')) {
					const dataStr = line.substring(6).trim()

					if (dataStr === '[DONE]') {
						if (callbacks.onDone) {
							callbacks.onDone()
						}
						return
					}

					// try {
					const data = JSON.parse(dataStr)

					if (data.event === 'message' && callbacks.onMessage) {
						callbacks.onMessage(data)
					} else if (data.event === 'complete' && callbacks.onComplete) {
						callbacks.onComplete(data)
					} else if (data.event === 'error' && callbacks.onError) {
						callbacks.onError(data?.message || '未知错误')
					}
					// } catch (e) {
					// 	console.error('解析SSE数据失败 e:', e)
					// 	console.error('fail dataStr: ', dataStr)
					// }
				}
			}
		}

		// } catch (error) {
		// 	if (error.name === 'AbortError') {
		// 		console.log('请求已被取消')
		// 	} else {
		// 		console.error('流式请求失败:', error)
		// 		if (callbacks.onError) {
		// 			callbacks.onError(error.message || '请求失败')
		// 		}
		// 		Message.error('请求失败: ' + error.message)
		// 	}
		// } finally {
		// 	this.abortController = null
		// }
	}

	/**
	 * 使用EventSource的流式聊天（简单版）
	 */
	streamChatWithEventSource(messages, options = {}, callbacks = {}) {
		const requestData = {
			messages,
			options: {
				model: options.model || 'doubao-pro',
				temperature: options.temperature || 0.7,
				top_p: options.top_p || 0.9,
				max_tokens: options.max_tokens || 4096,
				...options,
			},
			session_id: options.session_id || this.generateSessionId(),
		}

		const token = getToken()
		const url = new URL(`${this.baseURL}/api/chat/stream`)

		// EventSource不支持POST，只能通过GET参数传递
		url.searchParams.set('data', JSON.stringify(requestData))
		if (token) {
			url.searchParams.set('token', token)
		}

		const eventSource = new EventSource(url.toString())

		eventSource.onmessage = (event) => {
			try {
				const data = JSON.parse(event.data)

				if (data.event === 'message' && callbacks.onMessage) {
					callbacks.onMessage(data.data)
				} else if (data.event === 'complete' && callbacks.onComplete) {
					callbacks.onComplete(data.data)
				} else if (data.event === 'error' && callbacks.onError) {
					callbacks.onError(data.data?.message || '未知错误')
					eventSource.close()
				} else if (data.event === 'done' && callbacks.onDone) {
					callbacks.onDone()
					eventSource.close()
				}
			} catch (e) {
				console.error('解析EventSource数据失败:', e)
			}
		}

		eventSource.onerror = (error) => {
			console.error('EventSource错误:', error)
			if (callbacks.onError) {
				callbacks.onError('连接错误')
			}
			eventSource.close()
		}

		return eventSource
	}

	/**
	 * 普通聊天（非流式）
	 */
	async chat(messages, options = {}) {
		try {
			const response = await aiChat({
				messages,
				options: {
					model: options.model || 'doubao-pro',
					temperature: options.temperature || 0.7,
					top_p: options.top_p || 0.9,
					max_tokens: options.max_tokens || 4096,
					...options,
				},
			})

			return response
		} catch (error) {
			console.error('聊天请求失败:', error)
			Message.error('请求失败: ' + error.message)
			throw error
		}
	}

	/**
	 * 生成会话ID
	 */
	generateSessionId() {
		return Date.now().toString(36) + Math.random().toString(36).substr(2)
	}

	/**
	 * 取消当前请求
	 */
	cancelRequest() {
		if (this.abortController) {
			this.abortController.abort()
			this.abortController = null
		}
	}
}

export default new AIChatService()